import React from 'react';
import css from './Sections.module.css';
import heroImage from '../Images/landing-finding-banner.png';
function HeroSection() {
  return (
    <div className={css.heroSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.heroImg}>
          <img src={heroImage} alt="image" />
        </div>
        <div className={css.heroInfo}>
          <h2>Groundworks Contractors</h2>
          <p>
            Before your build can rise, the groundwork has to be solid. At The Modern Builder, we
            connect you with locally trusted groundworks contractors who understand what it takes to
            prepare your site properly—safely, efficiently, and in line with your construction
            goals.
          </p>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
